import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TInputForm from "../../common/TInputForm";

class DaumShowForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        onChange({
            setting: {
                show_width: this.props.data.setting.show_width||'190',
                show_keyword: this.props.data.setting.show_keyword||'검색어'
            },
            validated: !plugin.active
        })
    }

    @autobind
    handleShowWidthChange(value) {
        const { onChange } = this.props
        onChange({
            setting: {
                show_width: value,
                show_keyword: this.props.data.setting.show_keyword
            },
            validated: true
        })
    }

    @autobind
    handleShowKeywordChange(value) {
        const { onChange } = this.props
        onChange({
            setting: {
                show_width: this.props.data.setting.show_width,
                show_keyword: value
            },
            validated: true
        })
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin3">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        검색창 폭은
                        <TInputForm type="number" className="tf_set tf_set78" onChange={this.handleShowWidthChange} value={data.setting.show_width||'190'} />
                        px로 적용합니다.
                        <span className="txt_other">최소 130px</span>
                    </div>
                    <div className="item_set item_sub">
                        기본 검색 키워드
                        <TInputForm className="tf_set tf_set200" onChange={this.handleShowKeywordChange} value={data.setting.show_keyword||'검색어'} />
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

DaumShowForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default DaumShowForm
